import Dashboard from "../../component/dashboard/Dashboard";
import MobileDashboard from "../../component/mobile/dashboard/M_Dashboard";

const DashboardView = () => {
  return (
    <div className="DASHBOARD">
      {window.innerWidth > 1000 && <Dashboard />}
      {window.innerWidth < 1000 && <MobileDashboard />}
    </div>
  );
};

export default DashboardView;
